// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"319":"e2cd9d88","1809":"5f1279c9","2228":"5f1279c9","2700":"5f1279c9","3041":"5f1279c9","5160":"5f1279c9","6508":"bb27a280","8674":"5f1279c9","9546":"8308e96f"}[chunkId] + ".chunk.css";
};